module.exports = __webpack_public_path__ + "img/r-52.7dbe0f09.jpg";